/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Onboarding_GreetingInputs */



/**
* | output |
* | --- |
* | "Nice to meet you, {name}!" |
*
* @param {Onboarding_GreetingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const onboarding_greeting = /** @type {((inputs: Onboarding_GreetingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_GreetingInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Schön, dich kennenzulernen, ${i?.name}!`)
	return /** @type {LocalizedString} */ (`Nice to meet you, ${i?.name}!`)
});